<template>
  <div class="pc-container">
    <!-- ===== 顶部导航 ===== -->
    <el-header class="header">
      <div class="header-left">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入商品名称"
          size="medium"
          clearable
          @clear="clearSearch"
          @keyup.enter.native="handleSearch"
          class="search-input"
        />
        <el-button type="primary" size="medium" @click="handleSearch" style="margin-left: 0.5rem;">搜索</el-button>
      </div>
      <div class="header-right">
        <el-button size="medium" icon="el-icon-refresh" @click="handleSearch">刷新</el-button>
      </div>
    </el-header>

    <!-- ===== 商品表格 ===== -->
    <el-main>
      <div v-if="loading && (!goodsList || goodsList.length === 0)" class="loading-container">
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div v-else-if="!goodsList || goodsList.length === 0" class="empty-state">
        <i class="el-icon-document" style="font-size: 60px; color: #ccc;"></i>
        <p>暂无商品数据</p>
      </div>
      <el-table
        v-else
        ref="table"
        :data="goodsList"
        border
        stripe
        height="70vh"
        style="width: 97%"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="goods_name" label="商品名称" min-width="220" show-overflow-tooltip />
        <el-table-column label="图片" width="80" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.goods_img"
              :src="scope.row.goods_img"
              fit="cover"
              :preview-src-list="[scope.row.goods_img]"
              style="width: 50px; height: 50px; border-radius: 4px;"
            />
            <i v-else class="el-icon-picture-outline" style="font-size: 32px; color: #ccc;"></i>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_v1" label="规格" min-width="140" show-overflow-tooltip />
        <el-table-column prop="goods_brand" label="品牌" width="120" show-overflow-tooltip />
        <el-table-column prop="sh_name" label="所属店铺" min-width="120" show-overflow-tooltip />
        <el-table-column label="价格" width="150" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.comlist_f2_1>0">
              <span style="color: #f56c6c; font-weight: 600;">¥{{ scope.row.comlist_f2_1 }}</span>
              <span v-if="scope.row.comlist_f2" style="color: #999; text-decoration: line-through; margin-left: 6px; font-size: 12px;">
                ¥{{ scope.row.comlist_f2 }}
              </span>
            </div>
            <span v-else-if="scope.row.comlist_f2">¥{{ scope.row.comlist_f2 }}</span>
            <span v-else style="color: #999;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '上架' ? 'success' : 'info'" size="small">
              {{ scope.row.status || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分类标签" min-width="200">
          <template slot-scope="scope">
            <el-tag
              v-for="(tag, index) in scope.row.cate_goods"
              :key="index"
              size="small"
              style="margin: 2px 4px;"
              type="info"
            >
              {{ tag.name }}
            </el-tag>
            <span v-if="!scope.row.cate_goods || scope.row.cate_goods.length === 0" style="color: #999;">未绑定</span>
          </template>
        </el-table-column>
        <el-table-column prop="goods_create" label="创建时间" width="170" />
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-if="totalPages > 0"
        background
        layout="total, prev, pager, next"
        :total="totalPages * pageSize"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="fetchGoodsList"
        style="margin-top: 16px; text-align: right; width: 98%; background-color: #fff;"
      />
    </el-main>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'GoodsDetail',
  data () {
    return {
      // 搜索
      searchKeyword: '',
      // 列表数据
      goodsList: [],
      loading: false,
      currentPage: 1,
      pageSize: 20,
      totalPages: 0
    }
  },
  mounted () {
    this.fetchGoodsList()
  },
  methods: {

    // 1. 获取商品明细列表
    async fetchGoodsList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.searchKeyword.trim()) {
          // 若后端搜索参数名不同，请按实际情况调整
          params.goods_name = this.searchKeyword.trim()
        }
        const res = await request.post('/rcadmin/homeCateGoodsMx.php?a=goodsList', params)
        if (res && res.code === '0' && Array.isArray(res.res)) {
          this.goodsList = res.res
          this.totalPages = parseInt(res.pages) || 1
        } else {
          this.goodsList = []
          this.totalPages = 0
        }
      } catch (error) {
        console.error('获取商品明细列表失败', error)
        this.goodsList = []
        this.totalPages = 0
      } finally {
        this.loading = false
      }
    },

    // 2. 搜索
    handleSearch () {
      this.currentPage = 1
      this.fetchGoodsList()
    },
    clearSearch () {
      this.searchKeyword = ''
      this.handleSearch()
    }
  }
}
</script>

<style scoped>
.pc-container {
  height: 85vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background-color: #f0f2f5;
}
.header {
  background-color: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  min-height: 64px;
  height: auto;
  flex-wrap: wrap;
  gap: 8px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.header-left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.header-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}
.search-input {
  width: 220px;
}
.el-main {
  flex: 1;
  padding: 0px 24px;
  overflow-y: auto;
  background-color: #fff;
}
.loading-container,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.loading-container .el-icon-loading {
  font-size: 40px;
  color: #409EFF;
  margin-bottom: 16px;
}
.empty-state p {
  color: #999;
  margin-top: 12px;
}
.el-table {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.el-icon-picture-outline {
  font-size: 32px;
  color: #ccc;
}
@media screen and (max-width: 1100px) {
  .header { padding: 8px 16px; }
  .header-right { gap: 6px 10px; }
  .search-input { width: 160px; }
}
@media screen and (max-width: 820px) {
  .header { flex-direction: column; align-items: stretch; gap: 6px; }
  .header-left { justify-content: center; }
  .header-right { justify-content: center; flex-wrap: wrap; }
  .search-input { width: 140px; }
}
</style>
